import { Directive } from '@angular/core';

@Directive({
  selector: '[xpoTileRibbonCompact]',
  host: {
    class: 'xpo-TileRibbon--compact',
  },
})
export class XpoTileRibbonCompactDirective {}
